import Utils from "../util/Utils";

export default class FakturaciaCtrl {

  constructor(FakturaciaService) {
    this.FakturaciaService = FakturaciaService;

    this.dateFrom = null;
    this.dateTo = null;
    this.type = 'all';
    this.language = 'CS';
    this.extUis = null;
  }

  exportDuf() {
    this.FakturaciaService.exportDuf(
      this.dateFrom ? Utils.getDate(this.dateFrom) : null,
      this.dateTo ? Utils.getDate(this.dateTo) : null,
      this.type,
      this.language,
      this.extUis
    );
  }

  exportPof() {
    this.FakturaciaService.exportPof(
      this.dateFrom ? Utils.getDate(this.dateFrom) : null,
      this.dateTo ? Utils.getDate(this.dateTo) : null,
      this.type,
      this.language,
      this.extUis
    );
  }

}



// WEBPACK FOOTER //
// ./src/Fakturacia/FakturaciaCtrl.js